import { CompanyTagType } from '@api';
import { AddressFields, ContactFields, FormActions } from '@common';
import { MultiSelectField, TextField } from '@hypeit-gmbh/hypeit-ui';
import { Fieldset, Grid, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_KEY = 'ADD_COMPANY.FIELDS';

type AddCompanyFormFieldsPropsType = {
  onClose: () => void;
  companyTags: CompanyTagType[];
};

export const AddCompanyFormFields: React.FC<AddCompanyFormFieldsPropsType> = ({
  onClose,
  companyTags,
}) => {
  const { t } = useTranslation('companies');

  return (
    <Stack gap="xs">
      <Fieldset legend={t(`${TRANS_KEY}.BASIC_INFORMATION`)}>
        <Grid>
          <Grid.Col span={6}>
            <TextField
              fieldName="name"
              label={t(`${TRANS_KEY}.COMPANY_NAME`)}
              required
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextField
              fieldName="shortname"
              label={t(`${TRANS_KEY}.SHORTNAME`)}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextField fieldName="website" label={t(`${TRANS_KEY}.WEBSITE`)} />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextField
              fieldName="vatId"
              label={t(`${TRANS_KEY}.VAT_ID`)}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <MultiSelectField
              fieldName="categories"
              label={t(`${TRANS_KEY}.CATEGORIES`)}
              data={companyTags}
              searchable
            />
          </Grid.Col>
        </Grid>
      </Fieldset>
      <ContactFields.Root>
        <ContactFields.Phone />
        <ContactFields.Fax />
        <ContactFields.Email />
      </ContactFields.Root>
      <AddressFields.Root>
        <AddressFields.Street />
        <AddressFields.Addition />
        <AddressFields.Zip />
        <AddressFields.City />
        <AddressFields.Country />
      </AddressFields.Root>
      <FormActions
        onCancel={onClose}
        saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
        cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
      />
    </Stack>
  );
};
